import { Box, Button, Modal, Card, Typography, IconButton, TextField } from "@mui/material"

import { Add, Close, CloudUpload, Delete, DeleteRounded, Pause, SmartDisplay } from "@mui/icons-material"
import { useEffect, useRef, useState } from "react"
import { MediaPlayer, MediaPlayerInstance, MediaProvider, Poster } from "@vidstack/react"
import {
    defaultLayoutIcons,
    DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";

import { axiosInstance } from "../../utils/tokenSetCookie";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const API_UPLOAD_URL = import.meta.env.VITE_UPLOAD_MYVIDEO__URL;
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { CircularProgressWithLabel } from "../../utils/progressBar";
import { useCart } from "../../hooks/shareContext";
import { t } from "i18next";

// import { useTranslation } from "react-i18next";

const MAX_SIZE_MB = 100;
const MAX_WIDTH = 1920;
const MAX_HEIGHT = 1080;

type UploadData = {
    thumbImage: string | File;
    videoUrl: string | File;
    videoTitle: string;
    type: string;
}
type UploadURL = {
    thumbImage: string;
    videoUrl: string;
    videoTitle: string;

}
type UploadedFile = {
    fileName: string,
    src: string,
    size: number,
    poster: string,
    title: "",
    dimension?: string
}


export default function DoctorsVideos({ data, setData, externalData, setExternalData, type }: any) {
    const { setMyVideosAnim, cartCount, setCartCount } = useCart();
    const [progress, setProgress] = useState(0);
    const [showProgress, setShowProgress] = useState(false);
    // const { t } = useTranslation();
    const [isDragging, setIsDragging] = useState(false);
    const [isDraggingImage, setIsDraggingImage] = useState<boolean>(false);
    const videoPlayerRef = useRef<MediaPlayerInstance | null>(null);
    console.log(videoPlayerRef.current?.paused)

    const fileInputRef = useRef(null);

    const videoRef = useRef<HTMLVideoElement>(null);

    const [playVideo, setPlayVideo] = useState(false)

    const stored = localStorage.getItem("myVideosAnim");
    const storedIds: number[] = stored ? JSON.parse(stored) : [];
    console.log(storedIds, "from local storage")

    const [video, setVideo] = useState(() =>
        data && data.length > 0
            ? {
                video: data[0].videoUrl,
                title: data[0].videoTitle,
                id: data[0].id
            }
            : {
                video: "",
                title: "",
                id: ""
            }
    );

    const [openUplodaModal, setOpenUploadModal] = useState(false);
    const [opendeleteModal, setOpenDeleteModal] = useState(false);

    const [poster, setPoster] = useState("")


    const [videoURL, setVideoURL] = useState<UploadURL>({
        thumbImage: "",
        videoUrl: "",
        videoTitle: "",
    })


    const [uploadedFile, setUploadedFile] = useState<UploadedFile>({
        fileName: "",
        src: "",
        size: 0,
        poster: "",
        title: "",
        dimension: ""
    });


    const [uploadData, setUploadData] = useState<UploadData>({
        type: "",
        videoUrl: "",
        videoTitle: "",
        thumbImage: ""
    })

    console.log(playVideo, "play video")
    console.log(video, "state video")


    const byetsToMb = (bytes: number) => {
        const mb = bytes / (1024 * 1024);
        return mb
    }
    const useVideoSizeMB = (url: string) => {
        const [size, setSize] = useState<number | null>(null);

        useEffect(() => {
            if (!url) return;
            fetch(url, { method: "HEAD" })
                .then((res) => {
                    const contentLength = res.headers.get("content-length");
                    if (contentLength) {
                        const sizeInMB = (parseInt(contentLength) / (1024 * 1024));
                        setSize(Number(sizeInMB.toFixed(2)));
                    }
                })
                .catch(() => setSize(null));
        }, [url]);

        return size;
    };

    const VideoSizeDisplay = ({ url }: { url: string }) => {
        const sizeMB = useVideoSizeMB(url);
        return <span>{sizeMB !== null ? `${sizeMB} MB` : "..."}</span>;
    };


    useEffect(() => {
        return () => {
            if (uploadedFile.src) {
                URL.revokeObjectURL(uploadedFile.src);
            }
        };
    }, [uploadedFile.src]);
    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {
            setVideo({
                video: data[0].videoUrl,
                title: data[0].videoTitle,
                id: data[0].id
            });
        }
    }, [data])



    const [error, setError] = useState("");
    const [posterError, setPosterError] = useState("");



    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const validateVideo = (file: any) => {
        const allowedTypes = ["video/mp4", "video/webm"];

        if (!allowedTypes.includes(file.type)) {
            setError("Only MP4 and WebM video formats are allowed.");
            return Promise.resolve(false);
        }
        if (file.size > MAX_SIZE_MB * 1024 * 1024) {
            setError("File is too large. Please upload a video below 100MB.");
            return Promise.resolve(false);
        }

        return new Promise((resolve) => {
            const video = document.createElement("video");
            video.preload = "metadata";
            video.onloadedmetadata = () => {
                if (video.videoWidth > MAX_WIDTH || video.videoHeight > MAX_HEIGHT) {
                    setError("Video dimensions must be ≤ 1920x1080 pixels.");
                    resolve(false);
                } else {
                    console.log(video.videoWidth, "x", video.videoHeight)
                    resolve(true);
                }
            };
            video.onerror = () => {
                setError("Invalid video file.");
                resolve(false);
            };
            video.src = URL.createObjectURL(file);
        });
    };
    const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
    const MAX_IMAGE_SIZE_MB = 5;
    const isDisabled = uploadedFile.poster !== "" || uploadedFile.fileName === "";

    const validateImage = (file: File): Promise<boolean> => {
        return new Promise((resolve) => {
            if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                setPosterError("Only JPEG, PNG, WEBP, and GIF formats are allowed.");
                return resolve(false);
            }

            if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
                setPosterError("Image is too large. Please upload a file under 5MB.");
                return resolve(false);
            }

            // Optional: you can check image dimensions here if needed
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => {
                setPosterError("Invalid image file.");
                resolve(false);
            };
            img.src = URL.createObjectURL(file);
        });
    };

    const handleDrop = async (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        console.log("Dropped")
        if (e.dataTransfer.files.length === 0) {
            setError("No files were dropped.");
            setIsDragging(false);
            return;
        }
        setIsDragging(false);
        // e.stopPropagation();
        setError("");

        const file = e.dataTransfer.files[0];
        if (file) {
            console.log("This is valid", file)

            const isValid = await validateVideo(file);
            if (isValid) {
                const videoURL = URL.createObjectURL(file);
                setIsDragging(false);
                setUploadedFile({
                    ...uploadedFile,
                    fileName: file.name,
                    src: videoURL,
                    size: Math.floor(byetsToMb(file.size)),
                });
            } else {
                setUploadedFile(uploadedFile);
            }
        }
    };
    const handleImageDrop = async (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDraggingImage(false);

        const file = e.dataTransfer.files?.[0];
        if (!file) {
            setPosterError("No file dropped.");
            return;
        }

        setPosterError("");

        const isValid = await validateImage(file);
        if (isValid) {
            const imageURL = URL.createObjectURL(file);

            setUploadedFile({
                ...uploadedFile,
                poster: imageURL,
            });
            setUploadData({ ...uploadData, thumbImage: file })
            setPoster(imageURL);
        }
    };
    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(true);
        console.log("Dragging over")
    };

    const handleFileSelect = async (e: any) => {
        const file = e.target.files[0];
        setError("");
        if (file) {
            const isValid = await validateVideo(file);
            if (isValid) {
                const videoURL = URL.createObjectURL(file);
                setUploadedFile({
                    ...uploadedFile,
                    fileName: file.name,
                    src: videoURL,
                    size: Math.floor(byetsToMb(file.size)),
                });

                setUploadData({ ...uploadData, videoUrl: file, })
            } else {
                setUploadedFile(uploadedFile);
            }
        }
    };


    const resetUpload = () => {
        setUploadData({ thumbImage: "", type: "", videoTitle: "", videoUrl: "" })
        setUploadedFile({ fileName: "", src: "", size: 0, poster: "", title: "" });
        setError("");
        setPoster("");
        setPosterError("")
    };

    const captureScreenshot = () => {
        const video = videoRef.current;
        if (!video) return;

        const FRAME_TO_CAPTURE = 20;
        const FRAME_RATE = 30;
        const targetTime = FRAME_TO_CAPTURE / FRAME_RATE; // e.g., 0.67s

        const handleSeeked = () => {
            // Create a canvas and draw the frame
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const ctx = canvas.getContext("2d");
            ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);


            const imageDataUrl = canvas.toDataURL("image/png");
            setUploadedFile({ ...uploadedFile, poster: imageDataUrl })
            setUploadData({ ...uploadData, thumbImage: imageDataUrl })
            setPoster(imageDataUrl)

            // Clean up event
            video.removeEventListener("seeked", handleSeeked);
        };

        video.addEventListener("seeked", handleSeeked);
        video.currentTime = targetTime;
    };

    const handleUploadApi = async () => {

        if (uploadData.videoTitle === "") return toast.error("Please fill the required fields")
        if (uploadData.videoUrl !== "" && uploadData.thumbImage === "") return toast.error("Please fill the required fields")


        //Upload External Video's
        if (videoURL.videoUrl !== "" && videoURL.thumbImage !== "") {
            if (uploadData.videoTitle === "") return toast.error("Please fill the required fields")

            if (uploadData.videoTitle !== "" && videoURL.videoUrl === "") return toast.error("Please fill the required fields")

            if (uploadData.videoTitle !== "" && videoURL.videoUrl !== "" && videoURL.thumbImage === "") return toast.error("Please fill the required fields")
            const getFormData = new FormData();
            getFormData.append("type", "3");
            getFormData.append("videoUrl", videoURL.videoUrl);
            getFormData.append("thumbImage", videoURL.thumbImage);
            getFormData.append("videoTitle", uploadData.videoTitle);
            try {
                setShowProgress(true);
                setProgress(0);

                const response = await axiosInstance.post(
                    `${API_BASE_URL}my-videos/add`,
                    getFormData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent: any) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent?.total);
                        setProgress(percentCompleted);
                    }
                }
                );
                console.log("getFormData:", getFormData);

                if (response.status >= 200 && response.status < 300) {
                    resetUpload();
                    console.log("API Response:", response.data);
                    const newData = response.data?.data?.createdVideo;
                    const { thumbImage, videoTitle, videoUrl, id } = newData
                    const newVideo = {
                        thumbImage, videoTitle, videoUrl, id
                    }
                    console.log("newVideo", newVideo)
                    setExternalData([...externalData, newVideo]);

                } else {
                    console.error("API Failed:", response.status);
                }
            } catch (error) {
                const err = error as AxiosError;
                toast.error(err?.message ?? "Something went wrong");
            } finally {
                setShowProgress(false);
                setProgress(0); // reset for next upload
                setOpenUploadModal(prev => !prev)
                toast.success("URL Added Successfully!");

            }
            return
        }


        //Upload Doctor's Video & Patient's Video
        if (uploadData.videoUrl !== "" && uploadData.thumbImage !== "") {
            if (uploadData.videoTitle === "") return toast.error("Please fill the required fields")

            setShowProgress(true);
            setProgress(0);

            let progressValue = 0;

            const timer = setInterval(() => {
                progressValue += 5;
                if (progressValue < 95) {
                    setProgress(progressValue);
                } else {
                    clearInterval(timer);
                }
            }, 500);


            const getFormData = new FormData();

            getFormData.append("type", type);

            getFormData.append("videoUrl", uploadData.videoUrl);


            getFormData.append("videoTitle", uploadData.videoTitle);

            if (uploadData.thumbImage) {
                if (typeof uploadData.thumbImage === "string") {
                    // Screenshot case — it's a data URL
                    const blob = await (await fetch(uploadData.thumbImage)).blob();
                    getFormData.append("thumbImage", blob, "thumbnail.png");
                } else if (uploadData.thumbImage instanceof File) {
                    // Manual file upload
                    getFormData.append("thumbImage", uploadData.thumbImage);
                }
            }

            // console.log("Form Data:", getFormData);
            try {

                const response = await axiosInstance.post(
                    `${API_BASE_URL}my-videos/add`,
                    getFormData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },

                    }
                );

                setProgress(100)
                if (response?.status >= 200 && response?.status < 300) {
                    resetUpload()
                    setOpenUploadModal(prev => !prev)
                    const newData = response.data?.data?.createdVideo;
                    const { thumbImage, videoTitle, videoUrl, id, createdOn } = newData
                    const newVideo = {
                        thumbImage, videoTitle, videoUrl, id, createdOn
                    }
                    // console.log("newVideo", newVideo)
                    setData([...data, newVideo]);
                    // setData((prev: any) => [...prev, newVideo])
                    // setLoading(false)
                    // setUploadedFile({ ...uploadedFile, fileName: "", src: "", size: 0, poster: "", title: "" })
                    // setPoster("")
                    // setError("")
                    // console.log("API Response:", response.data);
                    toast.success("Video Added Successfully!")
                    // setAlert(prev => !prev)

                } else {
                    // console.error("API Failed:", response.status);
                }

            } catch (error) {
                const err = error as AxiosError;
                toast.error(err?.message ?? "Something went wrong");
                clearInterval(timer);
            }
            finally {
                // setIsUploading(false);
                clearInterval(timer);
                setTimeout(() => {
                    setShowProgress(false);
                    setProgress(0);
                }, 500);
            }
        }

    }

    const isChecked = storedIds.includes(video.id);

    console.log("id really in shared animation", isChecked)
    const handleDeleteApi = async () => {
        try {
            const response = await axiosInstance.delete(
                `${API_BASE_URL}my-videos/delete/${video.id}`, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            );

            if (response.status >= 200 && response.status < 300) {
                if (isChecked) {
                    const updatedIds = storedIds.filter((x) => x !== video.id);
                    setMyVideosAnim(updatedIds);
                    const newCount = Math.max(cartCount - 1, 0);
                    setCartCount(newCount)

                }
                const updatedArray = data.filter((item: any) => item.id !== video.id);
                setData(updatedArray);
                // console.log("API Response:", response.data);

            } else {
                // console.error("API Failed:", response.status);
            }

        } catch (error) {
            const err = error as AxiosError;
            // console.log(video.id)
            toast.error(err?.message ?? "Something went wrong");
        } finally {
            setOpenDeleteModal(prev => !prev)
            toast.success("Video Deleted Successfully!")

        }

    }

    useEffect(() => {
        const videoEl = videoPlayerRef.current;
        if (!videoEl) return;

        const handleCanPlay = () => {
            if (playVideo) videoEl.play();
        };

        videoEl.addEventListener('canplay', handleCanPlay);
        return () => videoEl.removeEventListener('canplay', handleCanPlay);
    }, [video, playVideo]);



    return (
        <>

            {/* Delete Modal */}
            <Modal
                open={opendeleteModal}
                onClose={() => setOpenDeleteModal(prev => !prev)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", }}

            >
                <Box sx={{ bgcolor: "whitesmoke", borderRadius: "5px", width: "500px" }}>

                    <Typography sx={{ fontWeight: "bold", fontSize: "20px", p: "10px", borderBottom: "1px solid rgba(160, 160, 160, 0.47)" }}>{t("doctor_videos")}</Typography>

                    <Box sx={{ p: "20px", }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", gap: "20px", alignItems: "center" }}>
                            <Typography sx={{ fontSize: "20px" }}>Are you sure want to delete this video?</Typography>
                        </Box>

                        <Box sx={{ mt: "30px", display: "flex", justifyContent: "end", gap: "20px" }}>
                            <Button onClick={() => setOpenDeleteModal(prev => !prev)} variant="outlined">No</Button>
                            <Button onClick={handleDeleteApi} variant="contained">Yes</Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Upload Modal */}
            <Modal
                open={openUplodaModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{
                    maxWidth: { xs: "80%", md: "1000px" }, mx: "auto", display: "flex",
                    pointerEvents: showProgress ? "none" : "auto",
                    justifyContent: "center", alignItems: "center", overflow: "hidden",

                }}
            >
                <>
                    <Box sx={{ bgcolor: showProgress ? "#cccccc" : "#f5f5f5", borderRadius: "5px", width: "100%" }}>
                        <Box sx={{ alignItems: "center", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(160, 160, 160, 0.47)", p: "20px", }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: "20px", mb: "10px" }}>Upload Video</Typography>
                            <Close sx={{ fontSize: "25px", cursor: "pointer" }} onClick={() => {
                                setOpenUploadModal(prev => !prev)
                                setUploadedFile({ ...uploadedFile, fileName: "", src: "" })
                                setError("")
                                setPoster("")
                                setIsDragging(false)
                                setIsDraggingImage(false)
                                setVideoURL({ ...videoURL, videoUrl: "", videoTitle: "", thumbImage: "" })
                                resetUpload()
                            }} />
                        </Box>
                        <Box sx={{ px: "20px", py: "10px", display: { xs: "none", md: "block" } }}>
                            <Typography sx={{ color: "red", fontSize: "14px" }}>
                                {t("please_upload_video_below_100mb")}
                            </Typography>
                            <Typography sx={{ color: "red", fontSize: "14px", mb: 2 }}>
                                {t("video_dimensions_equal_to_1920x1080")}
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: "92%", md: "47%" }, px: "20px" }}>
                            <TextField id="outlined-basic" label="Video Title" variant="outlined" sx={{ width: "100%", height: "40px", my: "20px" }}
                                onChange={(e) => {
                                    setUploadData({ ...uploadData, videoTitle: e.target.value });
                                }} />
                        </Box>

                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: { xs: "", md: "1fr 1fr" },
                                gap: "30px",
                                p: "20px",
                            }}
                        >
                            {/* Column 1 */}
                            <Box sx={{
                                pointerEvents: videoURL.videoUrl !== "" || videoURL.thumbImage !== "" || showProgress ? "none" : "auto",
                                opacity: videoURL.videoUrl !== "" || videoURL.thumbImage !== "" ? 0.6 : 1,
                                // border: "1px solid rgb(222, 221, 221)",
                                borderRadius: "4px",
                                px: "5px"


                            }}>
                                {uploadedFile.fileName ? (
                                    <Box sx={{ borderRadius: "4px" }}>
                                        {/* Video Preview */}
                                        <Box sx={{ gap: "10px", width: "100%", position: "relative" }}>
                                            <DeleteRounded
                                                onClick={resetUpload}
                                                sx={{
                                                    cursor: "pointer",
                                                    "&:hover": { color: "primary.main" },
                                                    position: "absolute",
                                                    right: "-15px",
                                                    top: "-10px",
                                                    fontSize: "25px",
                                                    bgcolor: "white",
                                                    borderRadius: "50%",
                                                    boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
                                                    padding: "5px",
                                                    zIndex: 1,
                                                }}
                                            />
                                            <Box sx={{ width: "100%", }}>
                                                <video ref={videoRef} src={uploadedFile.src} controls controlsList="nodownload" />
                                                <Typography sx={{ my: "10px" }}>
                                                    {uploadedFile.fileName}{" "}
                                                    {uploadedFile.size > 0 ? `(${uploadedFile.size} MB)` : ""}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                ) : (
                                    <Box sx={{ width: "100%" }}>
                                        {/* Upload Dropzone */}
                                        <Box
                                            onDragOver={handleDragOver}
                                            onDragLeave={handleDragLeave}
                                            onDrop={handleDrop}
                                            sx={{
                                                border: "2px dashed #ccc",
                                                height: "30vh",
                                                width: "100%",
                                                borderRadius: "8px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                cursor: "pointer",
                                                backgroundColor: isDragging ? "#e0e0e0" : "#f0f0f0",
                                                transition: "0.2s",
                                                transform: "translateZ(0)",
                                            }}
                                        >
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                accept="video/*"
                                                style={{ display: "none" }}
                                                id="video-upload-input"
                                                onChange={handleFileSelect}
                                            />
                                            <label htmlFor="video-upload-input" style={{ cursor: "pointer", textAlign: "center" }}>
                                                <CloudUpload fontSize="large" color="action" />
                                                <Typography sx={{ mt: 1, pointerEvents: "none" }}>
                                                    {t("drag_and_drop_video_here")}
                                                </Typography>
                                                <Typography>(or)</Typography>
                                                <Typography
                                                    sx={{
                                                        mt: 1,
                                                        backgroundColor: "primary.main",
                                                        py: "8px",
                                                        borderRadius: "4px",
                                                        color: "white",
                                                    }}
                                                >
                                                    {t("click_to_upload")}
                                                </Typography>
                                            </label>
                                        </Box>

                                        {/* File info */}
                                        {uploadedFile.fileName && (
                                            <Box
                                                sx={{
                                                    mt: 2,
                                                    p: 1,
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    backgroundColor: "#f8f8f8",
                                                }}
                                            >
                                                <Typography variant="body2">{uploadedFile.fileName}</Typography>
                                                <IconButton size="small" onClick={resetUpload}>
                                                    <Close fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        )}

                                        {error && (
                                            <Typography sx={{ mt: 1, color: "red", fontSize: "14px" }}>
                                                {error}
                                            </Typography>
                                        )}
                                    </Box>
                                )}
                            </Box>

                            {/* Column 2 */}
                            <Box
                                sx={{
                                    pointerEvents: videoURL.videoUrl !== "" ? "none" : "auto",
                                    opacity: videoURL.videoUrl !== "" ? 0.6 : 1,
                                    borderRadius: "4px",
                                    p: "10px",
                                    display: { xs: "none", md: "flex" },
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    textAlign: "center",
                                    gap: "20px",
                                    border: "2px dashed #ccc",
                                }}
                            >
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", }}>
                                    <Button
                                        variant="contained"
                                        sx={{}}
                                        disabled={uploadedFile.poster !== "" || uploadedFile.fileName === ""}
                                        onClick={captureScreenshot}
                                    >
                                        {t("take_screenshot_for_thumbnail_video")}
                                    </Button>

                                    <Box>{poster && <img src={poster} width={100} height={100} />}</Box>
                                    <Typography>(or)</Typography>

                                    <Box
                                        onDragOver={(e) => {
                                            if (isDisabled) return;
                                            e.preventDefault();
                                        }}
                                        onDragEnter={() => !isDisabled && setIsDraggingImage(true)}
                                        onDragLeave={() => !isDisabled && setIsDraggingImage(false)}
                                        onDrop={(e) => {
                                            if (!isDisabled) handleImageDrop(e);
                                        }}
                                        style={{
                                            border: isDraggingImage ? "2px dashed #2196f3" : "2px dashed #ccc",
                                            padding: "20px",
                                            textAlign: "center",
                                            opacity: isDisabled ? 0.5 : 1,
                                            pointerEvents: isDisabled ? "none" : "auto", // This disables interaction
                                            cursor: isDisabled ? "not-allowed" : "pointer",
                                        }}
                                    >
                                        {isDraggingImage
                                            ? "Drop your image here"

                                            : "Drag and drop an image file here"}
                                    </Box>

                                    {posterError && (
                                        <Typography sx={{ mt: 1, color: "red", fontSize: "14px" }}>
                                            {posterError}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Box>


                        <Box sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "", md: "1fr 1fr" },
                            gap: "20px", p: "20px",
                            pointerEvents: uploadedFile.fileName !== "" ? "none" : "auto",
                            opacity: uploadedFile.fileName !== "" ? 0.6 : 1,
                        }}>
                            <Box sx={{ my: { xs: "", md: "10px" } }}>
                                <Typography sx={{ textAlign: "center", mb: { xs: "20px", md: "0px" } }}>(or)</Typography>
                                <TextField id="outlined-basic" label="Video URL" variant="outlined" sx={{ width: "100%", my: 1 }} onChange={(e) => setVideoURL({ ...videoURL, videoUrl: e.target.value })} />
                                <Typography sx={{
                                    fontSize: "12px", color: "blue"
                                }}
                                >Exg URL: https://ent.com/3571264-uhd_2560_1440_30fps.mp4</Typography>

                            </Box>
                            <Box sx={{ my: { xs: "", md: "10px" } }}>
                                <Typography sx={{ textAlign: "center", display: { xs: "none", md: "block" } }}>(or)</Typography>
                                <TextField id="outlined-basic" label="Thumbnail URL" variant="outlined" sx={{ width: "100%", my: 1, }} onChange={(e) => setVideoURL({ ...videoURL, thumbImage: e.target.value })} />
                                <Typography sx={{ fontSize: "12px", color: "blue", }}>Exg URL: https://ent.com/3571264-uhd_2560_1440_30fps.jpeg</Typography>

                            </Box>
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "end", p: "20px", borderTop: "1px solid rgba(160, 160, 160, 0.47)" }}>
                            <Button variant="contained" sx={{ borderTop: "1px" }} disabled={showProgress} onClick={handleUploadApi}
                            >{t("submit")}</Button>
                        </Box>
                        <Box sx={{ width: "100%", alignItems: "center", display: "flex", justifyContent: "center", position: "absolute", top: "50%", zIndex: 2 }}>
                            {showProgress && <CircularProgressWithLabel value={progress} size={60} />}
                        </Box>
                    </Box >
                </>
            </Modal >


            {/* Card Section */}


            < Box sx={{ display: "flex", flexDirection: { xs: "column-reverse", lg: "row" }, gap: "30px", width: "100%" }
            }>

                {data.length !== 0 ? (
                    <>

                        {/* Left Bar */}

                        < Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(1, 1fr)',
                            gap: 2,
                            width: "100%",
                            maxWidth: { xs: "100%", lg: "400px" },
                            height: "100%",
                            cursor: "pointer",
                            maxHeight: "500px",
                            overflowY: "auto",
                            position: "relative",
                        }}>
                            {
                                data?.map((doctor: any) => {
                                    const videoUrl = `${API_UPLOAD_URL}${doctor.videoUrl}`;
                                    return (
                                        <Box key={doctor.id} sx={{
                                            position: "relative",
                                            overflow: "hidden",
                                            width: "100%",
                                            // maxHeight: "120px",
                                            height: "100%",
                                            borderRadius: 1,
                                            // boxShadow: 3,
                                            maxWidth: "400px",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",

                                        }}>
                                            <Card
                                                key={doctor.id}
                                                sx={{ display: "flex", gap: "10px", bgcolor: doctor.videoTitle == video.title ? "#e8f1ff" : "" }}
                                                onClick={() => {
                                                    if (doctor.id !== video.id) {
                                                        setPlayVideo(false);
                                                    }
                                                    setVideo({ ...video, title: doctor.videoTitle, video: doctor.videoUrl, id: doctor.id })

                                                }}
                                            >
                                                <Box component="img" loading="lazy" src={`${API_UPLOAD_URL}${doctor.thumbImage}`} width={120} height={120} sx={{ objectFit: "cover", backgroundSize: "cover" }} alt="doctor's video image" />

                                                <Box sx={{
                                                    width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", gap: "5px",
                                                }}>
                                                    <Typography sx={{ fontWeight: "bold", fontSize: "15px", textTransform: "capitalize" }}>{doctor?.videoTitle}</Typography>

                                                    <Typography sx={{ color: "gray", fontSize: "14px", display: "flex", alignItems: "center", gap: "4px" }}>
                                                        <VideoSizeDisplay key={doctor.id} url={videoUrl} />
                                                    </Typography>
                                                    <Box sx={{ width: "100%", display: "flex", gap: "10px", justifyContent: "end" }} >
                                                        <SmartDisplay onClick={() => {
                                                            setPlayVideo(prev => !prev)
                                                            setTimeout(() => {
                                                                videoPlayerRef.current?.play();
                                                            }, 100);
                                                        }
                                                        } sx={{
                                                            display: doctor?.id == video.id && playVideo ? "none" : "block",
                                                            fontSize: "25px", cursor: "pointer", "&:hover": {
                                                                color: "#1976d2",
                                                            }
                                                        }} />
                                                        <Pause onClick={() => {

                                                            setPlayVideo(prev => !prev)
                                                            setTimeout(() => {
                                                                if (videoPlayerRef.current?.play) {
                                                                    videoPlayerRef.current?.pause();
                                                                }
                                                            }, 100);
                                                        }}
                                                            sx={{ display: doctor?.id == video.id && playVideo ? "block" : "none" }} />
                                                        <Delete sx={{
                                                            fontSize: "25px", mr: "10px", cursor: "pointer", "&:hover": {
                                                                color: "#1976d2",
                                                            }
                                                        }} onClick={() => {
                                                            setVideo({ ...video, id: doctor.id })
                                                            setOpenDeleteModal(prev => !prev)
                                                        }} />
                                                    </Box>
                                                </Box>
                                            </Card>
                                        </Box>
                                    )
                                })

                            }
                            < Box sx={{
                                width: "100%",
                                maxHeight: "120px",
                                height: "100%",
                                textAlign: "center",
                                position: "sticky",
                                bottom: 0,
                            }} onClick={() => {
                                if (data.length === 5) {
                                    toast.error("You can add only 5 videos");
                                    // setAlert(prev => !prev)
                                    // setAlertMessage("You can add only 5 videos")
                                } else {
                                    setOpenUploadModal(prev => !prev)
                                }
                            }}>
                                <Button startIcon={<Add />} variant="contained">{t("add_new_video")}
                                </Button>
                            </Box >

                        </Box >

                        {/* Right Bar */}

                        < Box sx={{ width: { xs: "100%", xl: "65%" }, height: { xs: "200px", sm: "300px", md: "515px", } }}>
                            <MediaPlayer
                                ref={videoPlayerRef}
                                id={video.id}
                                // key={currentAnimationData?.tagName}
                                // id={`videoslider${currentAnimationData?.animationId}`}
                                // data-vds-id={VIDEO_BASE_URL}
                                className="carouselvideo"
                                src={
                                    `${API_UPLOAD_URL}${video.video}`
                                }
                                viewType="video"
                                streamType="on-demand"
                                logLevel="warn"
                                crossOrigin
                                playsInline
                                controls={false}
                                onPlay={() => setPlayVideo(true)}
                                onPause={() => setPlayVideo(false)}
                                // onLoadedMetadata={() => videoPlayerRef.current?.play()}
                                // onChange={(e) => console.log(video)}
                                // title={
                                //     currentAnimationData?.tagName
                                //         ? t(currentAnimationData?.tagName)
                                //         : ""
                                // }
                                title={video?.title}
                                // {isAnimationVideo?.animationTagName}
                                // poster={currentAnimationData?.bannerUrl}
                                // onPlay={handleVideoPlay} 
                                // ✅ Executes API once per video
                                style={{ height: "100%", borderRadius: "10px", textTransform: "capitalize" }}
                            //   onError={handleVideoError} // Handle video load errors
                            >
                                <MediaProvider>
                                    <Poster className="vds-poster" />
                                    {/* <QualityMenuButton />{" "} */}
                                    {/* Separate Quality Selection Button */}
                                </MediaProvider>
                                <DefaultVideoLayout icons={defaultLayoutIcons} />
                            </MediaPlayer>
                        </Box >
                    </>

                ) : (

                    <Box sx={{ mx: "30px" }}>
                        <Typography sx={{ display: "block", mb: 3 }}>No Videos Found</Typography>
                        < Box sx={{
                            width: "100%",
                            maxHeight: "120px",
                            height: "100%",
                            textAlign: "start",
                            position: "sticky",
                            bottom: 0,
                        }} onClick={() => {
                            if (data.length === 5) {
                                toast.error("You can add only 5 videos");
                                // setAlert(prev => !prev)
                                // setAlertMessage("You can add only 5 videos")
                            } else {
                                setOpenUploadModal(prev => !prev)
                            }
                        }}>
                            <Button startIcon={<Add />} variant="contained">{t("add_new_video")}
                            </Button>
                        </Box >
                    </Box>

                )}


            </Box >

            <>
            </>

        </>

    )
}